import { FaInstagram, FaEnvelope } from 'react-icons/fa'
import { useFooterVisibility } from '../context/FooterVisibilityContext'

export function Social() {
 const { isVisible } = useFooterVisibility()

 return (
  <div className="fixed bottom-0 z-10 p-4 flex flex-col items-center gap-2 max-[767px]:hidden">
   <div
    className={
     isVisible
      ? 'border-l h-24 border-white'
      : 'border-l h-24 border-[var(--text-main)]'
    }
   />
   <ul className="flex flex-col gap-2">
    <li>
     <a
      href="https://www.instagram.com/admancriativa"
      target="_blank"
      aria-label="Instagram da Adman"
      className={isVisible ? 'text-white' : 'text-[var(--text-main)]'}
     >
      <FaInstagram size={23} aria-hidden="true" />
     </a>
    </li>
    <li>
     <a
      href="mailto:contato@admancriativa.com.br"
      target="_blank"
      aria-label="Enviar email para Adman"
      className={isVisible ? 'text-white' : 'text-[var(--text-main)]'}
     >
      <FaEnvelope size={23} aria-hidden="true" />
     </a>
    </li>
   </ul>
  </div>
 )
}
